import { AcknowledgementOfDebt } from './acknowledgementOfDebt';
import { BaseModel } from './base.model';

export class Expense extends BaseModel {
  name: string = '';
  description: string = '';
  amount: number = 0;
  isAcknowledgementOfDebt: boolean = false;

  acknowledgementOfDebt?: AcknowledgementOfDebt;

  constructor(data?: Partial<Expense>) {
    super();
    Object.assign(this, data);
  }
}
